import { tns } from 'tiny-slider/src/tiny-slider';

export default function () {
  const SLIDER_CONTAINER_SELECTOR = '[data-marketing-slider]';
  const sliderPrev = document.querySelector('[data-slider-prev]')
  const sliderNext = document.querySelector('[data-slider-next]')

  const tinySliderContainer = document.querySelector(SLIDER_CONTAINER_SELECTOR);

  let slider; // eslint-disable-line no-unused-vars

  if (tinySliderContainer !== null) {
    slider = tns({
      container: tinySliderContainer,
      prevButton: sliderPrev,
      nextButton: sliderNext,
      loop: true,
      swipeAngle: 45,
      items: 1,
      mouseDrag: true,
      autoplay: true,
      nav: false,
      autoplayButtonOutput: false,
    });
  }
}
